import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { IResponseOK } from '../../../core/interfaces/responses.interface';
import {environment} from "../../../../environments/environment";
import {TokenResponse} from "../../../core/interfaces/token-response";
import {TokenStorageService} from "./token-storage.service";
import {BehaviorSubject} from "rxjs";
import {Account} from "../../../core/interfaces/account";
@Injectable()
export class AuthService {

  public $account: BehaviorSubject<Account> = new BehaviorSubject(null);

  constructor(
    private readonly http: HttpClient,
    private readonly tokenStorageService: TokenStorageService,
  ) {
  }

  public login(data): Observable<TokenResponse> {
    const url = `${environment.url}/api/authenticate`;

    return this.http.post<TokenResponse>(url , data);
  }

  public registration(body): Observable<IResponseOK> {
    const url = `${environment.url}/api/register`;

    return this.http.post<IResponseOK>(url , body);
  }

  public isUserLoggedIn(): boolean {
    return this.tokenStorageService.getToken() !== null;
  }

  public getAccount(): Observable<any> {
    const url = `${environment.url}/api/account`;

    return this.http.get(url);
  }

  public saveAccount(acc: Account): Observable<Account> {
    const url = `${environment.url}/api/account`;
    return this.http.post(url, acc);
  }

  public activateAccount(key: any): Observable<any> {
    const url = `${environment.baseUrl}/api/activate`;

    return this.http.get( url , {
      params: {'key': key}
    });
  }

  public logout(): void {
    this.tokenStorageService.removeToken();
    this.$account.next(null);
  }

  public loginUsingToken(token: string): void {
    this.tokenStorageService.storeToken(token);
  }
}
